import React from 'react';
import { motion } from 'framer-motion';
export function FinancialsSection() {
  return <section id="financials" className="pt-10 relative" data-id="element-35">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} data-id="element-36">
        <div className="mb-8 relative" data-id="element-37">
          <h2 className="text-5xl md:text-6xl font-bold mb-3 tracking-tight" data-id="element-38">
            FINANCIALS
          </h2>
          <div className="flex gap-2" data-id="element-39">
            {['#FF0000', '#FFDD00', '#00DD00'].map((color, i) => <div key={i} className="h-2 w-20" style={{
            backgroundColor: color
          }} data-id="element-40" />)}
          </div>
        </div>
        <div className="grid md:grid-cols-2 gap-6" data-id="element-41">
          <div className="space-y-4" data-id="element-42">
            <h3 className="text-xl font-bold" data-id="element-43">CAPITAL RESOURCES</h3>
            {[{
            title: 'PERSONAL INVESTMENT',
            amount: '€150k',
            color: '#0088FF'
          }, {
            title: 'KICKSTARTER GOAL',
            amount: '$100k',
            color: '#8800FF'
          }, {
            title: 'FRIENDS & FAMILY',
            amount: '$250k',
            color: '#00DD00'
          }].map((item, i) => <motion.div key={i} className="border-4 border-black p-4 bg-white relative" style={{
            borderLeftWidth: '10px',
            borderLeftColor: item.color
          }} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} data-id="element-44">
                <div className="flex justify-between items-center" data-id="element-45">
                  <h4 className="font-bold text-sm" data-id="element-46">{item.title}</h4>
                  <span className="text-xl font-bold" data-id="element-47">{item.amount}</span>
                </div>
              </motion.div>)}
            <div className="border-4 border-black p-4 bg-black text-white" data-id="element-48">
              <div className="flex justify-between items-center" data-id="element-49">
                <h4 className="font-bold text-sm" data-id="element-50">TOTAL CAPITAL</h4>
                <span className="text-2xl font-bold" data-id="element-51">~$520K</span>
              </div>
            </div>
          </div>
          <div className="space-y-4" data-id="element-52">
            <h3 className="text-xl font-bold" data-id="element-53">RUNWAY & REVENUE</h3>
            <div className="border-4 border-black p-5 bg-white relative" data-id="element-54">
              <h4 className="text-lg font-bold mb-3" data-id="element-55">PERSONAL RUNWAY</h4>
              <div className="text-4xl font-bold mb-2" style={{
              color: '#8800FF'
            }} data-id="element-56">
                18+ MONTHS
              </div>
              <p className="text-xs" data-id="element-57">Monthly cost: $3.7k</p>
            </div>
            <div className="border-4 border-black p-5 bg-white" data-id="element-58">
              <h4 className="text-lg font-bold mb-3" data-id="element-59">YEAR ONE TARGET</h4>
              <div className="text-4xl font-bold mb-4" style={{
              color: '#00DD00'
            }} data-id="element-60">
                $250K
              </div>
              <div className="space-y-2" data-id="element-61">
                {[{
                label: 'Sponsored Content',
                amount: '$98k',
                color: '#FF0000'
              }, {
                label: 'Services/Consulting',
                amount: '$103k',
                color: '#FF8800'
              }, {
                label: 'Early Membership',
                amount: '$49k',
                color: '#FFDD00'
              }].map((item, i) => <div key={i} data-id="element-62">
                    <div className="flex justify-between text-xs font-bold mb-1" data-id="element-63">
                      <span data-id="element-64">{item.label}</span>
                      <span data-id="element-65">{item.amount}</span>
                    </div>
                    <div className="w-full h-1.5 bg-gray-200" data-id="element-66">
                      <motion.div className="h-1.5" style={{
                    backgroundColor: item.color
                  }} initial={{
                    width: 0
                  }} whileInView={{
                    width: `${parseInt(item.amount.replace(/[^0-9]/g, '')) / 250 * 100}%`
                  }} viewport={{
                    once: true
                  }} transition={{
                    duration: 0.6,
                    delay: i * 0.1
                  }} data-id="element-67" />
                    </div>
                  </div>)}
              </div>
            </div>
          </div>
        </div>
      </motion.div>
    </section>;
}